/* eslint-disable max-len */
export default {
  // Login
  sendMessage: '메시지 발송',
  adminId: '어드민 아이디',
  adminPw: '어드민 비밀번호',
  loginBtn: '로그인',
  title: '서버관리자 인증',
  validationLoginIdNull: '아이디를 입력해주세요.',
  validationLoginPasswordNull: '비밀번호를 입력해주세요.',
  authFail: '유효하지 않은 아이디 혹은 패스워드 입니다.',
  mfaAuthFail: '발송한 인증번호와 일치하지 않습니다.',
  sendMfAuthCode: '인증번호를 발송 했습니다.',
  certificationMethod: '인증방법',
  smsCertification: 'SMS 인증',
  emailCertification: 'E-mail 인증',
  certificationTel: '관리자 번호',
  certificationEmail: '관리자 이메일',
  certificationCodeBtn: '인증코드 발송',
  certificationCode: '인증번호',
  certificationPlaceholder: '인증번호를 입력해주세요.',
  chooseRegistered: '등록된 항목을 선택하세요.',
  unpredictableFail: '로그인에 실패하였습니다.\n관리자에게 문의 부탁드립니다.',
  captionContent: `인증방법을 선택하고 관리자 번호(관리자 이메일)를 선택 후
    인증코드 발송 버튼을 클릭해주세요.
    인증코드를 수신 한 후, 수신된 값을 인증코드 입력 란에 기입 후
    확인 버튼을 클릭해주세요.`,
};
